import { render } from "./ComparasionPrice.vue?vue&type=template&id=6d4424e9&scoped=true"
import script from "./ComparasionPrice.vue?vue&type=script&lang=js"
export * from "./ComparasionPrice.vue?vue&type=script&lang=js"

import "./ComparasionPrice.vue?vue&type=style&index=0&id=6d4424e9&scoped=true&lang=css"
import "./ComparasionPrice.vue?vue&type=style&index=1&id=6d4424e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4424e9"]])

export default __exports__